import './App.css';
import Carousel from './components/Carousel';
import FlappyBird from './components/FlappyBird';
import LakePhoto from './components/LakePhoto';

function App() {
  return (
    <div className="app-container">
      <Carousel>
        <FlappyBird />
        <LakePhoto />
      </Carousel>
    </div>
  );
}

export default App;
